import styled from "styled-components";
import Colors from "../../utils/colors";
import Types from "../../utils/types";

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: ${({ justify }) => justify || Types.ALIGN_CENTER};
  align-items: ${({ align }) => align || Types.FLEX_ALIGN_START};
  align-content: ${({ align }) => align || Types.FLEX_ALIGN_START};

  @media screen and (max-width: 998px) {
    justify-content: start;
    padding-top: 130px;
    height: auto;

    &.small-padding-top {
      padding-top: 50px;
    }
  }
`;

export const Title = styled.h1`
  color: ${({ color }) => color || Colors.BLACK};
  font-family: ${({ font }) => font};
  position: relative;
  &.underlined:before {
    content: "";
    position: absolute;
    width: 50%;
    height: 10px;
    bottom: -20px;
    left: 25%;
    border-bottom: 1px solid ${({ color }) => color};
  }
`;
export const Subtitle = styled.h2`
  color: ${({ color }) => color || Colors.BLACK};
  font-family: ${({ font }) => font};
`;

export const DescriptionImage = styled.img`
  width: 70%;
  height: auto;
`;

export const Description = styled.div`
  color: ${({ color }) => color};
  line-height: var(--regular-line-height);
  font-size: var(--regular-font-size);
  font-family: var(--font-regular);
  color: ${({ color }) => color || Colors.BLACK};
  width: 100%;

  p {
    text-align: ${({ textAlign }) => textAlign || Types.ALIGN_START};
  }
  b {
    font-family: var(--font-bold);
  }

  div {
  }

  &.fading-text {
    height: 50%;
  }

  &.fading-text div {
    position: absolute;
  }
`;
